"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathwayChart = exports.background = void 0;
const react_1 = __importStar(require("react"));
const network_1 = require("@visx/network");
const tooltip_1 = require("@visx/tooltip");
const event_1 = require("@visx/event");
const basicNode_1 = require("./basicNode");
const curvedLine_1 = require("./curvedLine");
const groupNode_1 = require("./groupNode");
const getPos = ({ cent, rad, amount, iteration }) => {
    const degree = (360 / amount) * iteration;
    const changeY = cent.y - Math.sin((degree * Math.PI) / 180) * rad;
    const changeX = cent.x - Math.cos((degree * Math.PI) / 180) * rad;
    const ret = {
        x: Math.round(changeX * 1100) / 1000,
        y: Math.round(changeY * 950) / 1000,
    };
    return ret;
};
exports.background = "#FFFFFF";
const PathwayChart = ({ width, height, graph, tooltipL, tooltipT, }) => {
    const { containerRef, TooltipInPortal } = (0, tooltip_1.useTooltipInPortal)({
        scroll: true,
    });
    const { tooltipOpen, tooltipLeft, tooltipTop, tooltipData, hideTooltip, showTooltip, } = (0, tooltip_1.useTooltip)();
    const handleToolTip = (0, react_1.useCallback)((tooltipData) => (event) => {
        const { x, y } = (0, event_1.localPoint)(event) || { x: 0, y: 0 };
        showTooltip({
            tooltipData: tooltipData,
            tooltipLeft: x + tooltipL,
            tooltipTop: y + tooltipT,
        });
    }, [showTooltip]);
    const chartNodes = graph.nodes.filter((node) => {
        return node.group === undefined;
    });
    chartNodes.forEach((node) => {
        const rad = height / 3.2;
        const cent = {
            x: width / 3,
            y: height / 3,
        };
        const amount = chartNodes.length;
        const coords = getPos({
            rad,
            cent,
            amount,
            iteration: node.position,
        });
        node.x = coords.x;
        node.y = coords.y;
        if (node.groupContainer === true) {
            const groupNodes = graph.nodes.filter((n) => {
                return n.group === node.id;
            });
            const dimHeight = groupNodes.length * 60;
            node.groupDims.height = String(dimHeight);
            let yOffset = 7;
            groupNodes.forEach((gn) => {
                const groupY = node.y + yOffset;
                yOffset += 56;
                const groupX = node.x;
                gn.y = groupY;
                gn.x = groupX + parseInt(node.groupDims.width) / 5.5;
            });
        }
    });
    return width < 10 ? null : (react_1.default.createElement("div", { style: { position: "relative" } },
        react_1.default.createElement("svg", { width: width, height: height },
            react_1.default.createElement("rect", { width: width, height: height, rx: 14, fill: exports.background }),
            react_1.default.createElement(network_1.Graph, { graph: graph, top: 20, left: 100, nodeComponent: ({ node: { color, id, groupContainer, groupDims, data }, }) => groupContainer ? (react_1.default.createElement(groupNode_1.GroupNode, { groupProps: groupDims, id: id })) : (react_1.default.createElement(basicNode_1.BasicNode, { groupProps: groupDims, color: color, id: id, handleToolTip: handleToolTip, tooltipData: data, hideTooltip: hideTooltip })), linkComponent: ({ link: { source, target, lineSize } }) => {
                    return (react_1.default.createElement(curvedLine_1.CurvedLine, { source: source, target: target, lineSize: lineSize }));
                } })),
        tooltipOpen && tooltipData && (react_1.default.createElement("div", { style: {
                position: "absolute",
                top: tooltipTop,
                left: tooltipLeft,
                backgroundColor: "#EBF1F5",
                textAlign: "left",
                border: "thin solid #394B59",
                color: "#10161A",
                padding: "5px 5px",
                borderRadius: "6px",
                width: 200,
            } },
            react_1.default.createElement("strong", null, tooltipData.id),
            react_1.default.createElement("br", null),
            react_1.default.createElement("span", null,
                tooltipData.startDate,
                " - ",
                tooltipData.endDate),
            react_1.default.createElement("br", null),
            react_1.default.createElement("span", null, "Start list size:"),
            " ",
            tooltipData.startWaits,
            " ",
            react_1.default.createElement("br", null),
            react_1.default.createElement("span", null, "End list size:"),
            " ",
            tooltipData.endWaits,
            " ",
            react_1.default.createElement("br", null),
            react_1.default.createElement("span", null, "Growth:"),
            " ",
            tooltipData.pct,
            " %",
            react_1.default.createElement("br", null)))));
};
exports.PathwayChart = PathwayChart;
//# sourceMappingURL=main.js.map